import { CardComponentProps } from "@~/types/types";
import {
  transformVariantPrice,
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "./utils";
import { transformPricePerUnit } from "../__shared__/PriceUtils/priceUtils";
import { PricePresentation } from "../__shared__/PriceUtils/PricePresentation";
import { PricePerUnit } from "@~/types/prodcatBaseTypes";
import { useVariant } from "@~/contexts/VariantContext/VariantContext.tsx";

export function VariantPrice({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { variant } = useVariant();
  const pricePerUnit =
    (variant as { pricePerUnit?: PricePerUnit | null } | undefined)
      ?.pricePerUnit ?? undefined;

  if (!variant?.price) return null;
  const { price } = variant;

  const transformedVariantPrice = transformVariantPrice(price);

  if (!isPriceAtLeastMinimumThreshold(transformedVariantPrice)) return null;

  const unitPriceInfo = pricePerUnit
    ? transformPricePerUnit(pricePerUnit)
    : undefined;

  const creditMessage = getCreditMessage(transformedVariantPrice, product);

  return (
    <PricePresentation
      transformedVariantPrice={transformedVariantPrice}
      creditMessage={creditMessage}
      product={product}
      configProps={configProps}
      unitPriceInfo={unitPriceInfo}
    />
  );
}
